export class DownloadService {
    /**
     * Erstellt aus Binärdaten einen Download
     *
     * @param {Uint8Array<ArrayBufferLike>} bytes
     * @param {string} contentType
     * @param {string} fileName
     * @returns {void}
     */
    static downloadBytes(bytes, contentType, fileName) {
        const asBuffer = new ArrayBuffer(bytes.byteLength);
        new Uint8Array(asBuffer).set(bytes);
        const asBlob = new Blob([asBuffer], {
            type: contentType,
        });
        const asUrl = URL.createObjectURL(asBlob);
        const asLink = Object.assign(document.createElement('a'), {
            href: asUrl,
            download: fileName,
        });
        asLink.click();
        URL.revokeObjectURL(asUrl);
    }
}
